export const PRODUCT_SEARCH_PARAMS = [
  {
    id: 1,
    text: 'Código',
    parameter: 'produto.id_produto',
  },
  {
    id: 2,
    text: 'Referência',
    parameter: 'referencia_afere',
  },
  {
    id: 3,
    text: 'Descrição',
    parameter: 'produto.descricao',
  },
  {
    id: 4,
    text: 'Família',
    parameter: 'f.descricao',
  },
	{
    id: 4,
    text: 'Historico',
    parameter: 'historico',
  },
]
